import { call, put, takeEvery } from "redux-saga/effects";
import { giaoVienApi } from "../../../api/category/giaoVienApi";
import { IGiaoVien } from "../../../model/respone/category/IGiaoVien";
import { IBaseRespone } from "../../../model/respone/IBaseRespone";
import { eGiaoVienActionIds, IGiaoVienActionTypes } from "../../action-types/category/IGiaoVienActions";
import { rootActions } from "../../actions/rootActions";
const mainAction = rootActions.category.giaoVien;
export function* giaoVienSaga(): any {
  yield takeEvery(eGiaoVienActionIds.LOAD_START, loadWorker);
  yield takeEvery(eGiaoVienActionIds.SAVE_START, saveWorker);
  yield takeEvery(eGiaoVienActionIds.DELETE_START, deleteWorker);
}

function* loadWorker(): any {
  const res: IBaseRespone = yield call(giaoVienApi.SelectAll);
  if (res.is_success) {
    yield put(mainAction.LOAD_SUCCESS(res.data));
  } else {
    yield put(mainAction.LOAD_ERRR(res.message ?? "Có lỗi"));
  }
}

function* saveWorker(action: IGiaoVienActionTypes): any {
  let res: IBaseRespone;//= yield call(giaoVienApi.SelectAll);
  const payload = action.payload as IGiaoVien;
  if ((payload.id_cb ?? "") !== "") {
    res = yield call(giaoVienApi.Update, payload);
  } else {
    res = yield call(giaoVienApi.Insert, payload);
  }
  if (res.is_success) {
    yield put(mainAction.SAVE_SUCCESS(res.data));
  } else {
    yield put(mainAction.SAVE_ERRR(res.message ?? "Có lỗi"));
  }
}

function* deleteWorker(action: IGiaoVienActionTypes): any {
  const res: IBaseRespone = yield call(giaoVienApi.Delete, action.payload as number);
  if (res.is_success) {
    yield put(mainAction.DELETE_SUCCESS(res.data));
  } else {
    yield put(mainAction.DELETE_ERRR(res.message ?? "Có lỗi"));
  }
}